<template>
  <modal
      id="updateVacationCounter" v-cloak
      :dismissible="false">
    <div slot="title">
      <h4>Pas vakantiesaldo aan</h4>
    </div>
    <div></div>
    <div slot="body">
      <div class="color-fill"><b>Gebruiker</b></div>
      <div class="mb-3">{{user.userName}}</div>
      <div class="color-fill"><b>Type vakantie</b></div>
      <div class="mb-4">{{counter.typeHumanReadableFormat}}</div>
      <div id="currentBalance" class="row border rounded">
        <b class="col mt-4">Huidig saldo</b>
        <span class="col mt-4">{{currentBalance}}</span>
        <div class="btn-group-vertical col mt-1 mb-1">
          <button  class="btn btn-sm btn-secondary b-width" @click="addToCurrentBalance">
            <ChevronUpIcon/>
          </button>
          <button  class="btn btn-sm btn-secondary b-width" @click="subtractFromCurrentBalance">
            <ChevronDownIcon/>
          </button>
        </div>
      </div>
      <div class="m-2"></div>
      <div id="originalBalance" class="row border rounded">
        <b class="col mt-4">Origineel saldo</b>
        <span class="col mt-4">{{originalBalance}}</span>
        <div class="btn-group-vertical col mt-1 mb-1">
          <button  class="btn btn-sm btn-secondary b-width" @click="addToOriginalBalance">
            <ChevronUpIcon/>
          </button>
          <button  class="btn btn-sm btn-secondary b-width" @click="subtractFromOriginalBalance">
            <ChevronDownIcon/>
          </button>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button
          type="button" class="button-width btn btn-secondary mr-1"
          @click="handleReturnButton">Terug</button>
      <button
          type="button" class="button-width btn btn-primary"
          @click="handleSaveButton">Opslaan</button>
    </div>
  </modal>
</template>

<script>

import {VoerroModal} from "@voerro/vue-modal";
import {mapActions, mapGetters, mapMutations} from "vuex";
import ChevronUpIcon from "@/components/tables/icons/ChevronUp";
import ChevronDownIcon from "@/components/tables/icons/ChevronDown";

export default {
  name: "UpdateVacationCounterModal",
  components: {
    ChevronUpIcon,
    ChevronDownIcon
  },
  props: ['user', 'counter', 'year'],
  computed: {
    ...mapGetters({
      currentBalance: "administrationUser/currentBalance",
      originalBalance: "administrationUser/originalBalance"
    })
  },
  methods: {
    ...mapActions("administrationUser", ["updateVacationCounterBalances", "fetchVacationBalanceForAllUsersSpecificYear"]),
    ...mapMutations({
      setOriginalBalance: "administrationUser/setOriginalBalance",
      setCurrentBalance: "administrationUser/setCurrentBalance"
    }),
    handleReturnButton() {
      this.fetchVacationBalanceForAllUsersSpecificYear(this.year);
      VoerroModal.hide("updateVacationCounter");
    },
    handleSaveButton() {
      const userId = this.user.userId;
      const vacationCounterType = this.counter.type;
      const year = this.year;
      const currentBalanceToUpdate = this.currentBalance;
      const originalBalanceToUpdate = this.originalBalance;
      const updateVacationCounterDto = {
        type: vacationCounterType,
        currentBalance: currentBalanceToUpdate,
        originalBalance: originalBalanceToUpdate
      };
      this.updateVacationCounterBalances({year, userId, updateVacationCounterDto});
      VoerroModal.hide("updateVacationCounter");
    },
    addToOriginalBalance() {
      this.setOriginalBalance(this.originalBalance + 0.5);
      this.setCurrentBalance(this.currentBalance + 0.5);
    },
    subtractFromOriginalBalance() {
      if (((this.originalBalance - 0.5) >= 0) && ((this.currentBalance - 0.5) >= 0)) {
        this.setOriginalBalance(this.originalBalance - 0.5);
        this.setCurrentBalance(this.currentBalance - 0.5);
      }
    },
    addToCurrentBalance() {
      if (this.currentBalance < this.originalBalance) {
        this.setCurrentBalance(this.currentBalance + 0.5);
      }
    },
    subtractFromCurrentBalance() {
      if ((this.currentBalance - 0.5) >= 0) {
        this.setCurrentBalance(this.currentBalance - 0.5);
      }
    }
  }
};
</script>

<style scoped>
.color-fill {
  background-color: #B9DCD3;
}
.button-width {
  width: 100px;
}
.b-width {
  width: 40px;
}
</style>